import React, {lazy} from "react";
import {Route, Routes, Navigate} from "react-router-dom";

import {retryFailLoad} from "data/utils";
import {ModalTutorial} from "views/components/modals/modal_tutorial/modal_tutorial.component";
import {NotAuthOnlyRoute, PrivateRoute} from "views/components/route";
import BackdoorPage from "views/pages/backdoor/backdoor.page";
import {ModalPromoted} from "views/components/modals/modal_promoted/modal_promoted.component";

const Game = lazy(retryFailLoad(() => import("views/pages/game/game.page")));
const Tomorrow = lazy(
	retryFailLoad(() => import("views/pages/game/tomorrow_game/tomorrow_game.page"))
);
const Registration = lazy(
	retryFailLoad(() => import("views/pages/registration/registration.page"))
);
const ForgotPassword = lazy(
	retryFailLoad(() => import("views/pages/forgot_password/forgot_password.page"))
);
const ResetPassword = lazy(
	retryFailLoad(() => import("views/pages/reset_password/reset_password.page"))
);
const Help = lazy(retryFailLoad(() => import("views/pages/help/help.page")));
const NotFound = lazy(retryFailLoad(() => import("views/pages/not_found/not_found.page")));
const ComponentsReview = lazy(
	retryFailLoad(() => import("views/pages/components_review/components_review.page"))
);

const LeaderboardRosterView = lazy(
	retryFailLoad(
		() =>
			import("views/pages/league_levels/leaderboard_roster_view/leaderboard_roster_view.page")
	)
);

const LandingPage = lazy(retryFailLoad(() => import("views/pages/landing/landing.page")));
const HeadToHead = lazy(retryFailLoad(() => import("views/pages/head_to_head/head_to_head.page")));
const H2hChallengeViewPage = lazy(
	retryFailLoad(
		() =>
			import(
				"views/pages/head_to_head/h2h_manage_games/h2h_challenge_view/h2h_challenge_view.page"
			)
	)
);
const ManageGames = lazy(
	retryFailLoad(() => import("views/pages/head_to_head/h2h_manage_games/h2h_manage_games.page"))
);
const Friends = lazy(
	retryFailLoad(() => import("views/pages/head_to_head/h2h_friends/h2h_friends.page"))
);
const LeagueLevelsPage = lazy(
	retryFailLoad(() => import("views/pages/league_levels/league_levels.page"))
);

export const RootRoutes: React.FC = () => (
	<React.Fragment>
		<Routes>
			<Route path={"/"} element={<LandingPage />} />
			<Route element={<NotAuthOnlyRoute />}>
				<Route path="/registration" element={<Registration />} />
				<Route path="/forgot-password" element={<ForgotPassword />} />
				<Route path="/reset-password" element={<ResetPassword />} />
				<Route path="/backdoor" element={<BackdoorPage />} />
			</Route>
			<Route element={<PrivateRoute />}>
				<Route path="/play">
					<Route index={true} element={<Game />} />
					<Route path="next" element={<Tomorrow />} />
				</Route>
				<Route path="/head_to_head" element={<HeadToHead />}>
					<Route path="games" element={<ManageGames />}>
						<Route path=":userId" element={<H2hChallengeViewPage />} />
					</Route>
					<Route path="friends/:userCode" element={<Friends />} />
					<Route path="friends" element={<Friends />} />
					<Route index element={<Navigate to="games" replace />} />
					<Route path="*" element={<Navigate to="games" replace />} />
				</Route>
				<Route path="/leagues" element={<LeagueLevelsPage />}>
					<Route path=":userId/:contestId" element={<LeaderboardRosterView />} />
				</Route>
			</Route>
			<Route path="components" element={<ComponentsReview />} />
			<Route path="help/*" element={<Help />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
		<ModalTutorial />
		<ModalPromoted />
	</React.Fragment>
);

export default RootRoutes;
